/**
 * Section B6 Service - B.6.逆轉風險
 */
import axios from '../api/axios';

const BASE_URL = '/api/section-b6';

export interface SectionB6Detail {
  id: number;
  organization_id: number;
  project_id: number;
  risk_identification: string | null;
  risk_assessment: string | null;
  risk_mitigation_plan: string | null;
  risk_remediation: string | null;
  b_6: number;
  edit_by: number | null;
  created_at: string;
  updated_at: string | null;
}

export interface SectionB6Update {
  risk_identification?: string;
  risk_assessment?: string;
  risk_mitigation_plan?: string;
  risk_remediation?: string;
}

export const getSectionB6ByProject = async (projectId: number): Promise<SectionB6Detail | null> => {
  const response = await axios.get<SectionB6Detail>(`${BASE_URL}/by-project/${projectId}`);
  return response.data;
};

export const updateSectionB6 = async (projectId: number, data: SectionB6Update): Promise<SectionB6Detail> => {
  const response = await axios.put<SectionB6Detail>(`${BASE_URL}/${projectId}`, data);
  return response.data;
};

const sectionB6Service = { getSectionB6ByProject, updateSectionB6 };
export default sectionB6Service;
